<script setup>
import { IonBackButton } from "@ionic/vue";
import { useIonRouter } from "@ionic/vue";
import { useRouter } from "vue-router";

const ionRouter = useIonRouter();
const router = useRouter();
const navigateBack = () => {
  if (ionRouter.canGoBack()) {
    router.back();
  } else {
    router.push({ name: "home" });
  }
};
</script>

<template>
  <ion-back-button @click.prevent="navigateBack()"></ion-back-button>
</template>
